(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.banner');
  if (!section) return;
  const track = section.querySelector('.banner__track');
  const slides = Array.from(track.children);
  const dots = Array.from(section.querySelectorAll('.banner__dot'));
  let index = 0;
  const intervalSeconds = Number(section.getAttribute('data-interval')) || 5;
  let timer = null;

  function update() {
    track.style.transform = `translateX(-${index * 100}%)`;
    dots.forEach(dot => dot.classList.remove('active'));
    dots[index].classList.add('active');
  }

  function goTo(i) {
    index = i;
    update();
    resetAutoplay();
  }

  function next() {
    index = (index + 1) % slides.length;
    update();
  }

  function resetAutoplay() {
    if (timer) clearInterval(timer);
    if (slides.length > 1) {
      timer = setInterval(() => {
        next();
      }, intervalSeconds * 1000);
    }
  }

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      goTo(parseInt(dot.getAttribute('data-index')));
    });
  });

  update();
  resetAutoplay();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-title-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var track = document.querySelector('.carousel-track');
  var slides = document.querySelectorAll('.carousel-slide');
  var dotsContainer = document.querySelector('.carousel-dots');
  if (!track || slides.length === 0) return;

  function getSlidesPerView() {
    return window.innerWidth <= 900 ? 1 : 3;
  }

  function getMaxPage() {
    var slidesPerView = getSlidesPerView();
    return Math.max(0, slides.length - slidesPerView);
  }

  var currentPage = 0;

  function renderDots() {
    dotsContainer.innerHTML = '';
    var totalPages = getMaxPage() + 1;
    for (var i = 0; i < totalPages; i++) {
      var dot = document.createElement('div');
      dot.className = 'carousel-dot' + (i === 0 ? ' active' : '');
      dot.dataset.index = i;
      dotsContainer.appendChild(dot);
    }
    document.querySelectorAll('.carousel-dot').forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToPage(Number(this.dataset.index));
      });
    });
  }

  function goToPage(page) {
    var slidesPerView = getSlidesPerView();
    var maxPage = getMaxPage();
    if (page < 0) page = 0;
    if (page > maxPage) page = maxPage;
    currentPage = page;
    var offset = -(page * (100 / slidesPerView));
    track.style.transform = 'translateX(' + offset + '%)';
    document.querySelectorAll('.carousel-dot').forEach(function(dot, idx) {
      dot.classList.toggle('active', idx === page);
    });
  }

  function updateCarousel() {
    var slidesPerView = getSlidesPerView();
    track.style.width = (slides.length * (100 / slidesPerView)) + '%';
    slides.forEach(function(slide) {
      slide.style.minWidth = (100 / slidesPerView) + '%';
      slide.style.maxWidth = (100 / slidesPerView) + '%';
    });
    renderDots();
    goToPage(0);
  }

  // Swipe para mobile e drag para desktop
  function enableDragAndSwipe() {
    let slidesPerView = getSlidesPerView();
    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let diff = 0;

    // Touch (mobile)
    track.addEventListener('touchstart', function(e) {
      isDragging = true;
      startX = e.touches[0].clientX;
    });
    track.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    });
    track.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      diff = currentX - startX;
      if (diff > 50 && currentPage > 0) goToPage(currentPage - 1);
      if (diff < -50 && currentPage < getMaxPage()) goToPage(currentPage + 1);
      isDragging = false;
    });

    // Mouse (desktop)
    let mouseDown = false;
    let mouseStartX = 0;
    let mouseCurrentX = 0;
    let mouseDiff = 0;

    function preventDefault(e) { e.preventDefault(); }

    track.addEventListener('mousedown', function(e) {
      if (slidesPerView < 1) return;
      mouseDown = true;
      mouseStartX = e.clientX;
      track.style.cursor = 'grabbing';
      document.body.style.userSelect = 'none';
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
      document.addEventListener('mouseleave', onMouseUp);
      document.addEventListener('selectstart', preventDefault);
    });

    function onMouseMove(e) {
      if (!mouseDown) return;
      mouseCurrentX = e.clientX;
    }

    function onMouseUp(e) {
      if (!mouseDown) return;
      mouseDiff = mouseCurrentX - mouseStartX;
      if (mouseDiff > 50 && currentPage > 0) goToPage(currentPage - 1);
      if (mouseDiff < -50 && currentPage < getMaxPage()) goToPage(currentPage + 1);
      mouseDown = false;
      track.style.cursor = 'grab';
      document.body.style.userSelect = '';
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('mouseleave', onMouseUp);
      document.removeEventListener('selectstart', preventDefault);
    }
  }

  updateCarousel();
  enableDragAndSwipe();

  window.addEventListener('resize', function() {
    updateCarousel();
    enableDragAndSwipe();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
